import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './lib/utils/dev/clearFailedConsultations' // Make clearFailedConsultations available globally
import './lib/utils/dev/emergency-clear' // Make emergencyClear available globally

createRoot(document.getElementById("root")!).render(<App />);
